export const customIcons: { iconName: string, url: string }[] = [
  {
    iconName: 'export',
    url: '/assets/icons/export.svg'
  },
  {
    iconName: 'invoice',
    url: '/assets/icons/invoice-logo.svg'
  },
  {
    iconName: 'order',
    url: '/assets/icons/order-logo.svg'
  },
  {
    iconName: 'a-icon',
    url: '/assets/icons/a-icon.svg'
  },
  {
    iconName: 'positive_verified_symbol',
    url: '/assets/icons/positive_verified_symbol.svg'
  },
  {
    iconName: 'people_alt',
    url: '/assets/icons/people_alt.svg'
  },
  {
    iconName: 'feather_edit',
    url: '/assets/icons/feather-edit.svg'
  },
  {
    iconName: 'phone',
    url: '/assets/icons/phone.svg'
  },
  {
    iconName: 'mail',
    url: '/assets/icons/mail.svg'
  },
  {
    iconName: 'map-pin',
    url: '/assets/icons/map-pin.svg'
  },
  {
    iconName: 'survey_language',
    url: '/assets/icons/survey_language.svg'
  },
  {
    iconName: 'program_language',
    url: '/assets/icons/program_language.svg'
  },
  {
    iconName: 'accr_cert',
    url: '/assets/icons/accr_cert.svg'
  },
  {
    iconName: 'connected_dots',
    url: '/assets/icons/connected_dots.svg'
  },
  {
    iconName: 'services',
    url: '/assets/icons/services.svg'
  },
  {
    iconName: 'management',
    url: '/assets/icons/management.svg'
  },
  {
    iconName: 'notepad',
    url: '/assets/icons/notepad.svg'
  },
  {
    iconName: 'statement',
    url: '/assets/icons/statement.svg'
  },
  {
    iconName: 'd-management',
    url: '/assets/icons/d_management.svg'
  },
  {
    iconName: 'survey',
    url: '/assets/icons/survey.svg'
  },
  {
    iconName: 'implement',
    url: '/assets/icons/implement.svg'
  },
  {
    iconName: 'clipboard',
    url: '/assets/icons/clipboard.svg'
  },
  {
    iconName: 'standard',
    url: '/assets/icons/standard.svg'
  },
  {
    iconName: 'options',
    url: '/assets/icons/options.svg'
  },
  {
    iconName: 'chapter',
    url: '/assets/icons/chapter.svg'
  },
  {
    iconName: 'group',
    url: '/assets/icons/group.svg'
  },
  {
    iconName: 'request',
    url: '/assets/icons/request.svg'
  },
  {
    iconName: 'national_account',
    url: '/assets/icons/national-account.svg'
  }
];
